import React from "react";
import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const HeadlineAndButton = ({ blok }) => (
  <div className="flex justify-center" {...storyblokEditable(blok)}>
    <div className="headline-and-button-wrap flex flex-col justify-center">
      <div className="flex flex-col">
        <h2 className="text-2xl">{blok.subheadline}</h2>
      </div>

    <div className="headline-and-button-wrap-button-outer">

      <div className="headline-and-button-wrap-button">
        <Link target="_blank" href={blok.buttonLink} >
            <button className="btn">{blok.button}</button>
        </Link>
      </div>

      {blok.buttonLink2 && (
       <div className="headline-and-button-wrap-button">
        <Link target="_blank" href={blok.buttonLink2} >
            <button className="btn">{blok.button2}</button>
        </Link>
      </div>
      )}
    </div>
    </div>
  </div>
);

export default HeadlineAndButton;
